// Generated by genversion.
export const version = '5.23.1';
